import { useMemo } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { BaseCrud, Static } from 'core-components/types'

interface IUseStaticCrud {
  data: string[] | object[]
  keyField?: string
  displayField?: string
  pageSize?: number
  hierarchyField?: string
  hierarchyRoot?: string
}

/*
  Testing...not public yet.
 */

export const useStaticCrud = <T = IForm>({
  data,
  keyField = 'key',
  displayField = 'value',
  pageSize = 10,
  hierarchyRoot,
  hierarchyField,
}: IUseStaticCrud) => {
  return useMemo(() => {
    const crud = new BaseCrud<T>({
      fetcher: new Static<T>(
        data.map((el) => {
          if (typeof el === 'string') {
            return { [keyField]: el, [displayField]: el } as T
          }

          if (el[keyField] !== undefined && el[displayField] !== undefined) {
            return { ...el } as T
          }
          throw new Error('useStaticCrud:: Wrong Data')
        })
      ),
      keyField,
      hierarchyField,
      hierarchyRoot,
    })
    if (pageSize) {
      crud.setPaging({ page: 0, pageSize })
    }

    return crud
  }, [data, keyField, pageSize, displayField])
}
